import { Injectable } from '@zhfe/vue2-di-plugin'
import { UserService } from '@/services/user.service'

export interface PermissionInfo {
  /** 服务到期UNIX时间戳 */
  service_expire_time?: number
  /** 服务次数，注意是剩下的次数 */
  service_times?: number
}
@Injectable()
export class TranslateService {
  constructor (
    private user: UserService
  ) { }

  /** 是否为会员。 包括视频、极光PDF、毒霸会员 */
  get isVip (): boolean {
    return this.user.isMember || this.user.isPdfMember || this.user.isPdfLifeMember
  }

  /** 赠送的翻译次数 */
  get translatePresentNum (): number {
    const { service_times = 0, service_expire_time = 0 } = this.user.permissionInfo?.pdf_translate_present || {}
    return this.user.currentTime <= service_expire_time ? service_times : 0
  }

  /** 购买翻译 */
  get translateindependent (): PermissionInfo {
    return this.user.permissionInfo?.pdf_translate_independent
  }
}
